var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:{
    'button--active': _vm.active,
    'button--dark': _vm.type === 'dark',
    'button--tab': _vm.type === 'tab',
  },attrs:{"type":"button"},domProps:{"textContent":_vm._s(_vm.text)},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }